/**
 * BackToSettings — white "Go Back" link rendered at the top of every
 * settings sub-page (General, Billing, Integrations, Permissions &
 * Ownership, Payments & branding, etc.). Replaces the older purple
 * "All settings" affordance per user request (Iter 168).
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function BackToSettings({ to = '/website-builder/settings', label = 'Go Back' }) {
  return (
    <Link
      to={to}
      data-testid="settings-go-back"
      className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-white hover:text-[#A78BFA] transition-colors font-semibold"
    >
      <ArrowLeft size={12} /> {label}
    </Link>
  );
}
